var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconRiskOrange(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "22px",
    height: "22px",
    viewBox: "0 0 22 22",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "160744D5-8EF6-4398-8187-0AF2031FF0E9") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Design",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    opacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    id: "Hilbi-WebApp-Desktop-Chat_Detail",
    transform: "translate(-788.000000, -141.000000)",
    fill: "#F5BA42"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-22",
    transform: "translate(516.000000, 60.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-21",
    transform: "translate(24.000000, 81.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "BMI",
    transform: "translate(248.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11,0 C17.0751322,0 22,4.92486775 22,11 C22,17.0751322 17.0751322,22 11,22 C4.92486775,22 0,17.0751322 0,11 C0,4.92486775 4.92486775,0 11,0 Z M9.23641016,5.00653306 L4.29112891,13.9366736 C3.47885547,15.2793533 4.46227344,16.9796136 6.05430859,16.9796136 L15.9455273,16.9796136 C17.5362227,16.9796136 18.5213906,15.2807231 17.7091172,13.9366736 L12.7635898,5.00653306 C11.9690078,3.69253926 10.0320586,3.69079339 9.23641016,5.00653306 Z",
    id: "Combined-Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11,13.7564731 C11.4522109,13.7564731 11.8203125,14.1180558 11.8203125,14.5622583 C11.8203125,15.0064607 11.4522109,15.3680434 11,15.3680434 C10.5477891,15.3680434 10.1796875,15.0064607 10.1796875,14.5622583 C10.1796875,14.1180558 10.5477891,13.7564731 11,13.7564731 Z M11,7.31019215 C11.4522109,7.31019215 11.8203125,7.67177479 11.8203125,8.11597727 L11.8203125,12.1449029 C11.8203125,12.5891054 11.4522109,12.950688 11,12.950688 C10.5477891,12.950688 10.1796875,12.5891054 10.1796875,12.1449029 L10.1796875,8.11597727 C10.1796875,7.67177479 10.5477891,7.31019215 11,7.31019215 Z",
    id: "Combined-Shape"
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRiskOrange);
export default __webpack_public_path__ + "static/media/icon-risk-orange.0e00d857a6c885ff7a760882f3a7cb1a.svg";
export { ForwardRef as ReactComponent };